(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(".product-media-modal__content");
		if (!imagesWrapper) return;
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				if (imagesWrapper.classList.contains("zoom")) {
					imagesWrapper.classList.remove("zoom");
				} else {
					const rect = el.getBoundingClientRect();
					const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(0);
					const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(0);
					el.style.transformOrigin = `${x}% ${y}%`;
					imagesWrapper.classList.add("zoom");
				}
			});
		});
	};

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		const secondSection = document.querySelector('.product-section + section');
		const footer = document.querySelector('footer');

		if (!stickyBar || !secondSection || !footer) {
			console.error('Required elements not found!');
			return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;
			stickyBar.classList[activeOffset ? "add" : "remove"]('active');
		};

		handleScroll();
	};

	// ── AUTO-CIERRE DEL MODAL EN MÓVIL AL LLEGAR A LA ÚLTIMA FOTO ──
	const initModalAutoClose = () => {
		if (window.innerWidth > 750) return;

		const modal = document.querySelector('product-modal');
		if (!modal) return;

		// El scroll ocurre en .product-media-modal__dialog, no en .js-popup-slider
		const scrollContainer = modal.querySelector('.product-media-modal__dialog');
		if (!scrollContainer) return;

		let touchStartY = 0;
		let alreadyClosed = false;

		const isModalOpen = () => modal.hasAttribute('open');

		const isAtBottom = () => {
			return scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 80;
		};

		// Cierre por scroll: cuando llega al final del contenedor
		let scrollTimer = null;
		scrollContainer.addEventListener('scroll', () => {
			if (!isModalOpen()) return;
			if (scrollTimer) clearTimeout(scrollTimer);
			scrollTimer = setTimeout(() => {
				if (isAtBottom() && isModalOpen()) {
					modal.hide();
				}
			}, 400);
		}, { passive: true });

		// Cierre por swipe hacia abajo estando al final
		scrollContainer.addEventListener('touchstart', (e) => {
			touchStartY = e.touches[0].clientY;
			alreadyClosed = false;
		}, { passive: true });

		scrollContainer.addEventListener('touchend', (e) => {
			if (alreadyClosed || !isModalOpen()) return;
			const touchEndY = e.changedTouches[0].clientY;
			const swipedDown = touchEndY - touchStartY > 60;
			if (swipedDown && isAtBottom()) {
				alreadyClosed = true;
				modal.hide();
			}
		}, { passive: true });
	};
	// ── FIN AUTO-CIERRE ──

	document.addEventListener('scroll', () => revealPopup());

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initModalAutoClose();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();

	// Esperamos a que el DOM esté listo para el modal
	document.addEventListener('DOMContentLoaded', () => {
		initModalAutoClose();
	});
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

		const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

		const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(".product__description");
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector("pickup-availability");
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector("product-recommendations");
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);